import { render, staticRenderFns } from "./AlterarValorItemAditivoApostila.vue?vue&type=template&id=6d73b8b3"
import script from "./AlterarValorItemAditivoApostila.vue?vue&type=script&lang=js"
export * from "./AlterarValorItemAditivoApostila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports